import { useQuery } from '@tanstack/react-query';
import { productService, Product } from '@/services/productService';

export const useProducts = () => {
  return useQuery({
    queryKey: ['products'],
    queryFn: () => productService.getAll().then(res => res.data),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};

export const useProduct = (id: number) => {
  return useQuery({
    queryKey: ['products', id],
    queryFn: () => productService.getById(id).then(res => res.data),
    enabled: !!id,
  });
};

export const useProductSearch = (search: string, limit: number = 20) => {
  return useQuery({
    queryKey: ['products', 'search', search, limit],
    queryFn: () => productService.search(search, limit).then(res => res.data),
    staleTime: 30 * 1000, // 30 seconds for search results
    placeholderData: (previousData) => previousData, // Keep previous data while fetching
  });
};

// Export the type for use in components
export type { Product };
